import { caseStudies as caseStudiesZhTW, categories as categoriesZhTW } from './zh-TW';
import { caseStudies as caseStudiesEn, categories as categoriesEn } from './en';
import { caseStudies as caseStudiesJa, categories as categoriesJa } from './ja';

/**
 * 根據語言獲取對應的案例資料
 * @param {string} language - 語言代碼 ('zh-TW', 'en', 'ja')
 * @returns {Object} { caseStudies, categories }
 */
export const getCaseStudies = (language) => {
  const dataMap = {
    'zh-TW': { caseStudies: caseStudiesZhTW, categories: categoriesZhTW },
    'en': { caseStudies: caseStudiesEn, categories: categoriesEn },
    'ja': { caseStudies: caseStudiesJa, categories: categoriesJa }
  };

  return dataMap[language] || dataMap['zh-TW'];
};

/**
 * 根據 ID 和語言獲取特定案例
 * @param {string} caseId - 案例 ID
 * @param {string} language - 語言代碼
 * @returns {Object|undefined} 案例物件
 */
export const getCaseById = (caseId, language) => {
  const { caseStudies } = getCaseStudies(language);
  return caseStudies.find(c => c.id === caseId);
};

/**
 * 根據分類和語言獲取案例列表
 * @param {string} category - 分類 ID
 * @param {string} language - 語言代碼
 * @returns {Array} 案例陣列
 */
export const getCasesByCategory = (category, language) => {
  const { caseStudies } = getCaseStudies(language);
  if (category === 'all') return caseStudies;
  return caseStudies.filter(c => c.category === category);
};

/**
 * 獲取相關案例（同分類的其他案例）
 * @param {string} caseId - 當前案例 ID
 * @param {string} language - 語言代碼
 * @param {number} limit - 回傳數量限制
 * @returns {Array} 相關案例陣列
 */
export const getRelatedCases = (caseId, language, limit = 3) => {
  const currentCase = getCaseById(caseId, language);
  if (!currentCase) return [];

  const { caseStudies } = getCaseStudies(language);
  return caseStudies
    .filter(c => c.category === currentCase.category && c.id !== caseId)
    .slice(0, limit);
};
